'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	timeBucket = require('../models/time-bucket'),
	truncateSentence = require('../models/truncate-sentence'),
	bucketLabels = {
		'same-day': 'Today',
		'last-day': 'Yesterday',
		'same-month': 'This month',
		'last-month': 'Last month',
		'same-year': 'This year',
		'last-year': 'Last year',
		'older': 'A while ago...'
	};
require('./mm-scroll-into-view');

mmWidgets.fn.historyEventsWidget = function (params) {
	const {historyModel, pageController, isReadOnly} = params,
		eventCardRole = 'event-card',
		bucketRole = 'event-bucket',
		cardSelector = `[data-mm-role~="${eventCardRole}"]`;
	if (!historyModel || !pageController) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		let watermark = 0;
		const widget = this,
			existingBucketEvents = {},
			template = widget.find('[data-mm-role=template]'),
			readOnlyHeader = widget.find('[data-mm-role=read-only-header]'),
			bucketTemplate = widget.find('[data-mm-role=bucket-template]'),
			templateContainer = template.parent(),
			activateIndex = (eventIndex) => {
				templateContainer.find(`${cardSelector}.active`).removeClass('active');
				templateContainer.find(`${cardSelector}[data-mm-index="${eventIndex}"]`).addClass('active').mmScrollIntoView();
			},
			findOrCreateBucket = function (ts) {
				const bucketName = timeBucket(ts);
				if (!existingBucketEvents[bucketName]) {
					let bucket = templateContainer.find(`[data-mm-role=${bucketRole}][data-mm-bucket-name=${bucketName}]`);
					if (!bucket.length) {
						bucket = bucketTemplate.clone().attr({
							'data-mm-role': bucketRole,
							'data-mm-bucket-name': bucketName
						}).prependTo(templateContainer);
						bucket.find('[data-mm-role=bucket-label]').text(bucketLabels[bucketName]);
						bucket.find('[data-mm-role=bucket-header]').on('click', () => {
							bucket.toggleClass('collapsed');
						});
					}
					existingBucketEvents[bucketName] = bucket.find('[data-mm-role=bucket-events]');
				}
				return existingBucketEvents[bucketName];
			},
			addEventCard = async function (index) {
				const event = historyModel.getEventSummary(index),
					bucket = findOrCreateBucket(event.ts),
					card = template.clone().prependTo(bucket)
						.attr({
							'data-mm-role': eventCardRole,
							'data-mm-index': index,
							'tabIndex': 1
						})
						.on('click', () => {
							if (isReadOnly) {
								activateIndex(index);
							} else {
								historyModel.restoreUpTo(index);
							}
						})
						.on('dblclick', () => {
							if (isReadOnly) {
								pageController.openHistory(index);
							}
						}),
					eventDateElement = card.find('[data-mm-role=event-time]'),
					collaboratorElement = card.find('[data-mm-role=collaborator]'),
					descriptionElement = card.find('[data-mm-role=description]');
				if (event.ephemeral) {
					card.addClass('ephemeral');
				}
				if (event.ts) {
					eventDateElement.text(new Date(event.ts).toLocaleString());
				} else {
					eventDateElement.remove();
				}
				if (event.collaborator) {
					collaboratorElement.text(event.collaborator);
				} else {
					collaboratorElement.remove();
				}
				descriptionElement.text(truncateSentence(event.description, 200));
			},
			updateEventCardsUpTo = (eventCount) => {
				for (let eventIndex = watermark; eventIndex < eventCount; eventIndex++) {
					addEventCard(eventIndex);
				}
				watermark = eventCount;
			};
		bucketTemplate.remove();
		template.remove();
		if (!isReadOnly) {
			readOnlyHeader.remove();
		}
		historyModel.addEventListener('eventCount', eventCount => {
			if (!widget.hasClass('hidden')) {
				updateEventCardsUpTo(eventCount);
			}
		});
		historyModel.addEventListener('activeIndex', (index) => {
			if (!widget.hasClass('hidden')) {
				activateIndex(index);
			}
		});
		historyModel.addEventListener('hasWatermark', (hasWatermark) => {
			const watermarkSection = widget.find('[data-mm-role=watermark-message]');
			if (hasWatermark) {
				watermarkSection.removeClass('hidden');
			} else {
				watermarkSection.addClass('hidden');
			}
		});
		widget.on('show', () => {
			return Promise.resolve()
			.then(() => {
				widget.find('[data-mm-role=loading]').removeClass('hidden');
				templateContainer.addClass('hidden');
			})
			.then(() => updateEventCardsUpTo(historyModel.getEventCount()))
			.then(() => {
				widget.find('[data-mm-role=loading]').addClass('hidden');
				templateContainer.removeClass('hidden');
				widget.trigger('show:complete');
			});
		});
	});
};
